<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="2" lg="2">
          <v-select
            v-model="params.type"
            :items="listType"
            label="Type"
            outlined
            dense
            background-color="white"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" v-if="params.type === 1">
          <v-text-field
            v-model.number="params.amount"
            label="Income Amount"
            outlined
            dense
            background-color="white"
            type="number"
            :hint="formatPrice(params.amount)"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="3" lg="3">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.startDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.startDate"
              @input="menuStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3">
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.endDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2" class="py-0">
          <v-checkbox v-model="params.difference" label="Dengan Perbandingan"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn color="success" @click="excel">
            <v-icon>
              mdi-file-excel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import fileDownload from "js-file-download";

export default {
  name: "report-laba-rugi",
  data() {
    return {
      menuStartDate: false,
      menuEndDate: false,
      params: {
        startDate: moment()
          .startOf("year")
          .format("yyyy-MM-DD"),
        endDate: moment()
          .endOf("year")
          .format("yyyy-MM-DD"),
        difference: false,
        type: 0,
        amount: 130000000000,
      },
      listType: [
        { text: "Different Year", value: 0 },
        { text: "Same Year", value: 1 },
      ],
    };
  },
  computed: {
    ...mapState("report", ["labaRugi"]),
  },
  methods: {
    async excel() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("report/labaRugiExcelV2", this.params)
        .then(response => {
          fileDownload(response.data, `laba-rugi.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
